/**
 * @generated SignedSource<<76315d0a37dfce485918d07c6e818829>>
 * @relayHash 64d6ab389580affe2dc4588fe90df163
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6ded89305bb0fdf40d86385ff5debd2a9bdbd8867cb01d58dc353650b624e81

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "%future added value";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type servicesTrialSprintBoardProjectDataQuery$variables = {
  projectAri: string;
};
export type servicesTrialSprintBoardProjectDataQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly created: AGG$DateTime | null | undefined;
      readonly key: string;
      readonly projectStyle: JiraProjectStyle | null | undefined;
      readonly projectType: JiraProjectType | null | undefined;
      readonly status: JiraProjectStatus | null | undefined;
      readonly tmpBoardId: AGG$Long | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type servicesTrialSprintBoardProjectDataQuery = {
  response: servicesTrialSprintBoardProjectDataQuery$data;
  variables: servicesTrialSprintBoardProjectDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "status"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "created"
},
v5 = {
  "kind": "ScalarField",
  "name": "tmpBoardId"
},
v6 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v7 = {
  "kind": "ScalarField",
  "name": "projectType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e6ded89305bb0fdf40d86385ff5debd2a9bdbd8867cb01d58dc353650b624e81",
    "metadata": {},
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2cb31c05e90016e3ab24f63c4b4f98c4";

export default node;
